import Input from '../../common/Input';

export const contacts = {
  id: 0,

  name: 'contacts',
  _system: {
    name: 'Contacts',
    relatedTo: 'contacts',
  },
  contact_id: {
    name: 'id',
    value: '',
    system: {
      name: 'id',
      relatedTo: 'contacts',
    },
    rules: {},
  },
  firstname: {
    label: 'First Name',
    placeholder: 'Fill-in this field.',
    system: {
      component: Input,
      name: 'firstname',
      relatedTo: 'contacts',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'firstname',
    rules: {
      title: 'Firs name field',
      required: true,
    }
  },
  lastname: {
    label: 'Last Name',
    placeholder: 'Fill-in this field.',
    system: {
      component: Input,
      name: 'lastname',
      relatedTo: 'contacts',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'lastname',
    rules: {
      title: 'Last name field',
      required: true,
    }
  },
  email: {
    label: 'Email',
    placeholder: 'Fill-in this field.',
    value: '',
    system: {
      component: Input,
      name: 'email',
      relatedTo: 'contacts',
    },
    errors: [],
    type: 'email',
    name: 'email',
    rules: {
      title: 'Email field',
      required: true,
      email: true,
    }
  },
  phone: {
    label: 'Phone',
    placeholder: 'Fill-in this field.',
    system: {
      component: Input,
      name: 'phone',
      relatedTo: 'contacts',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'phone',
    rules: {
      title: 'Phone field',
    }
  },
};

export const basic = {
  name: {
    label: 'Name',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'Name field',
      required: true,
    }
  },
  contacts: [],
  remove_vendor_contact_ids: [],
};



// WEBPACK FOOTER //
// ./src/containers/VendorEdit/fields.js